import { ProductSubscriptionReportRequestDTO, UrbanSportsClubMembershipStatusImportRequestDTO } from '@iota/inh-core-v1-management-client';

export interface Month {
    zeroBasedIndex: number;
    name: string;
}

export const MONTHS: Month[] = [
    { zeroBasedIndex: 0, name: $localize`January` },
    { zeroBasedIndex: 1, name: $localize`February` },
    { zeroBasedIndex: 2, name: $localize`March` },
    { zeroBasedIndex: 3, name: $localize`April` },
    { zeroBasedIndex: 4, name: $localize`May` },
    { zeroBasedIndex: 5, name: $localize`June` },
    { zeroBasedIndex: 6, name: $localize`July` },
    { zeroBasedIndex: 7, name: $localize`August` },
    { zeroBasedIndex: 8, name: $localize`September` },
    { zeroBasedIndex: 9, name: $localize`October` },
    { zeroBasedIndex: 10, name: $localize`November` },
    { zeroBasedIndex: 11, name: $localize`December` }
];

export const MONTH_ENUM_BY_INDEX = [
    'JANUARY',
    'FEBRUARY',
    'MARCH',
    'APRIL',
    'MAY',
    'JUNE',
    'JULY',
    'AUGUST',
    'SEPTEMBER',
    'OCTOBER',
    'NOVEMBER',
    'DECEMBER'
] as const satisfies readonly (UrbanSportsClubMembershipStatusImportRequestDTO.MonthEnum & ProductSubscriptionReportRequestDTO.MonthEnum)[];
